import styled from "styled-components"

export const Panel = styled.div`
    background-color: ${props => props.theme.panel.background};
    padding: 1rem;
    color: ${props => props.theme.panel.color};
    border-radius: ${props => props.theme.format.borderradius};
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.35);
`